module.exports = __webpack_public_path__ + "static/media/customerFeel-relieved.986d4a6b.jpg";